import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export const ArrowUp = props => {
    return (_jsx(SvgIcon, { width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", ...props, children: _jsx("path", { d: "M8.9411e-07 7.63732L1.42739 9L8 2.72535L14.5726 9L16 7.63732L8 -6.03983e-07L8.9411e-07 7.63732Z", fill: "#1C1B1F" }) }));
};
